import { Home, FileText, Calculator, Hammer, PaintBucket, Ruler, Palette, ClipboardList } from "lucide-react";
import IndustryPlaceholderPage from "@/components/industry/IndustryPlaceholderPage";

const HomeServicesIndustry = () => (
  <IndustryPlaceholderPage
    name="Home Services"
    icon={Home}
    iconColor="text-warning"
    iconBg="bg-[hsl(var(--warning)/0.1)]"
    headline="Home Services Proposals"
    tagline="in Minutes"
    description="Sentinel Forge helps handyman, painting, and remodeling companies create professional project proposals, estimates, and service contracts — all from one platform."
    valueProps={[
      { title: "Win More Home Projects", description: "Build detailed project proposals with scope of work, material lists, and clear pricing that homeowners trust and approve faster." },
      { title: "Look Professional", description: "Generate polished, branded estimates and contracts that set you apart from competitors still using handwritten quotes." },
      { title: "Built for Home Services", description: "Templates for handyman work, interior/exterior painting, bathroom remodels, kitchen renovations, and general home repair." },
    ]}
    features={[
      { icon: Calculator, label: "Project Cost Estimators" },
      { icon: Ruler, label: "Scope of Work Builder" },
      { icon: FileText, label: "PDF Proposals" },
      { icon: Hammer, label: "Handyman Templates" },
      { icon: PaintBucket, label: "Painting Estimates" },
      { icon: ClipboardList, label: "Material Lists" },
      { icon: Palette, label: "Custom Branding" },
      { icon: Home, label: "Remodel Planning" },
    ]}
    benefits={[
      "Create project-specific proposals with room-by-room breakdowns, material lists, and labor estimates",
      "Auto-calculate costs based on project scope, materials, labor hours, and markups",
      "Generate branded proposals with before-photos and detailed work descriptions",
      "Send contracts with digital signatures for fast homeowner approval",
      "Track active projects, estimates, and follow-ups from one dashboard",
      "Support one-time projects and recurring maintenance agreements",
    ]}
    proposalTemplates={[
      "General Handyman Services",
      "Interior Painting Estimate",
      "Exterior Painting Estimate",
      "Bathroom Remodel Proposal",
      "Kitchen Renovation Proposal",
    ]}
    contractTemplates={[
      "Home Improvement Contract",
      "Painting Services Agreement",
      "Remodeling Project Contract",
      "Recurring Maintenance Agreement",
    ]}
    faq={[
      { q: "What is Sentinel Forge for home services?", a: "Sentinel Forge is a proposal and contract platform for handyman, painting, and remodeling businesses. It helps you create professional estimates, project proposals, and digital contracts." },
      { q: "Can I create proposals for different project types?", a: "Yes. Templates cover handyman work, painting, bathroom and kitchen remodels, flooring, drywall, and general home improvement projects." },
      { q: "How does cost estimation work?", a: "You define the project scope, materials, labor hours, and markup. The system calculates total project cost with clear line-item breakdowns." },
      { q: "Can I include photos in proposals?", a: "Yes. Proposals support before-photos, sketches, and material references to give homeowners a clear picture of the planned work." },
      { q: "Do homeowners need an account to sign?", a: "No. Homeowners receive a secure link to review and digitally sign contracts without creating an account." },
      { q: "Can I add my company's branding?", a: "Yes. Your logo, company name, and custom terms appear on every proposal and contract you generate." },
      { q: "When will home services be available?", a: "We're actively building it now. Join the waitlist to get early access when the home services module launches." },
      { q: "How do I get support?", a: "Reach our team at support@sentinelforge.com or through the in-app support ticket system." },
    ]}
    ctaHeadline="Ready to professionalize your home services business?"
    ctaDescription="Join home service companies preparing to automate estimates and client contracts with Sentinel Forge."
  />
);

export default HomeServicesIndustry;
